import React, { useState } from "react";
import { View, TextInput, TouchableOpacity, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import Text from "@components/AppText";
import colors from "@constants/color";
import { applyCouponCode } from "@services/api";
import { actions } from "@reducers/cartReducer";
import analytics from "@services/analytics";
import t from "@constants/localization";
import { COUPON_FLOW_EVENTS } from "../../constants/analyticsEventsCT";

const PATH = "screens/CouponScreen/ManualApplyCoupon";

const ManualApplyCoupon = ({
  handleToggleLoading = () => {},
  userId = "",
  cart_items,
  cart_value,
}) => {
  const navigation = useNavigation();
  const [couponCode, setCouponText] = useState("");
  const dispatch = useDispatch();

  const handleApplyCoupon = () => {
    handleToggleLoading(true);
    // Apply here at the same moment and then dispatch an action

    analytics.trackEvent(COUPON_FLOW_EVENTS.COUPON_APPLIED, {
      coupon: couponCode,
      user_id: userId,
      cart_items,
      cart_value,
      source: "Manually",
    });
    applyCouponCode({ couponCode, user_id: userId })
      .then(() => {
        analytics.trackEvent(COUPON_FLOW_EVENTS.COUPON_SELECTED, {
          coupon_name: couponCode,
          user_id: userId,
          cart_items,
          cart_value,
          source: "Manually",
        });
        dispatch(actions.toggleCartFetching());
        dispatch(actions.getAllCartItems(userId));
        handleToggleLoading(false);
        navigation.goBack();
      })
      .catch((e) => {
        handleToggleLoading(false);
      });
  };

  return (
    <View style={styles.textContainer}>
      <View
        style={{
          paddingLeft: 10,
          width: "70%",
        }}
      >
        <TextInput
          style={{
            textDecorationLine: "none",
            fontWeight: "bold",
          }}
          placeholder={t(`${PATH}/enterCoupon`)}
          autoCapitalize="characters"
          onChangeText={setCouponText}
        />
      </View>
      <TouchableOpacity
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "flex-end",
          width: "30%",
        }}
        onPress={handleApplyCoupon}
        disabled={!couponCode.length > 0}
      >
        <Text
          bold
          fontType="head3"
          style={{
            color: !couponCode.length > 0 ? colors.lightBlack : colors.primary,
          }}
        >
          {t(`${PATH}/apply`)}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  textContainer: {
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
    paddingRight: 10,
    borderRadius: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#fff",
  },
});

export default ManualApplyCoupon;
